import { Phone, Instagram, Youtube, MessageCircle } from "lucide-react";
import { Logo } from "./Navbar";
import { SITE, FOOTER } from "../config/content";
import { genericWhatsAppLink } from "../lib/api";

export default function Footer() {
  return (
    <footer className="border-t border-[#17231B] bg-[#0B110D] pt-14 pb-28 md:pb-10" data-testid="footer">
      <div className="max-w-[1180px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-[1.2fr_0.8fr_1fr] gap-10">
          <div>
            <Logo />
            <p className="mt-4 text-sm text-[#A7B3AA] leading-relaxed max-w-sm">
              India's live trading workspace. Learn a system, trade beside experts, and get every trade reviewed — online or offline.
            </p>
            <div className="mt-5 flex gap-3">
              {[
                { icon: Instagram, label: "Instagram", testid: "social-instagram" },
                { icon: Youtube, label: "YouTube", testid: "social-youtube" },
                { icon: MessageCircle, label: "WhatsApp", testid: "social-whatsapp", href: genericWhatsAppLink() },
              ].map(({ icon: Icon, label, testid, href }) => (
                <a
                  key={label}
                  href={href || "#"}
                  target={href ? "_blank" : undefined}
                  rel={href ? "noopener noreferrer" : undefined}
                  aria-label={label}
                  data-testid={testid}
                  className="w-10 h-10 rounded-full border border-[#22C55E]/25 flex items-center justify-center text-[#A7B3AA] hover:text-[#22C55E] hover:border-[#22C55E]/60 transition-colors"
                >
                  <Icon className="w-4.5 h-4.5 w-[18px] h-[18px]" />
                </a>
              ))}
            </div>
          </div>
          <div>
            <h3 className="font-heading uppercase text-white text-xl tracking-wide mb-4">Quick Links</h3>
            <ul className="space-y-2.5">
              {FOOTER.links.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-sm text-[#A7B3AA] hover:text-[#22C55E] transition-colors" data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}>
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h3 className="font-heading uppercase text-white text-xl tracking-wide mb-4">Reach Us</h3>
            <ul className="space-y-3 text-sm text-[#A7B3AA]">
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 text-[#22C55E] shrink-0 mt-0.5" />
                <a href={`tel:${SITE.phone.replace(/\s/g, "")}`} className="hover:text-[#22C55E] transition-colors" data-testid="footer-phone">{SITE.phone}</a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-12 rounded-xl border border-[#17231B] bg-[#070A08] p-5" data-testid="footer-disclaimer">
          <p className="text-xs text-[#6B7A70] leading-relaxed">{FOOTER.disclaimer}</p>
        </div>
        <p className="mt-6 text-center text-xs text-[#6B7A70]" data-testid="footer-copyright">{FOOTER.copyright}</p>
      </div>
    </footer>
  );
}
